new Swiper('.swiper-carousel-banner', {


   navigation: {
      prevEl: '.swiper-button-prev-carousel-banner',
      nextEl: '.swiper-button-next-carousel-banner'
   }
});

// new Swiper('.swiper-jaqueta', {


//    navigation: {
//       prevEl: '.swiper-button-prev-jaqueta',
//       nextEl: '.swiper-button-next-jaqueta'
//    }
// });



// const swiperLeft = new Swiper('.js-swiper-left', {
//    loop: true,

//    navigation: {
//       prevEl: '.swiper-button-prev-left'
//    }
// });

// const swiperRight = new Swiper('.js-swiper-right', {
//    loop: true,

//    navigation: {
//       nextEl: '.swiper-button-next-right'
//    }
// });
